import React from "react"
import PropTypes from "prop-types"

import moment from 'moment'

class LexSchedule extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit",
      lang_one: '',
      lang_two: ''
    }
    this.style = this.style.bind(this)
    this.instructionText = this.instructionText.bind(this)
  }

  style(n) {
    if(this.props.selected === n) {
      return{
        border: '3px solid #03A9F4',
        borderRadius: 3,
        backgroundColor: '#03A9F4',
        padding: 8,
        width: 150,
        display: 'inline-block',
        cursor: 'pointer',
      }
    }
    return{
      border: '3px solid #03A9F4',
      borderRadius: 3,
      padding: 8,
      width: 150,
      display: 'inline-block',
      cursor: 'pointer',
    }
  }

  instructionText() {
    let text = (this.props.selected === this.props.currentUserLanguage) ? "you want" : `${(this.props.otherUser.nickname != undefined && this.props.otherUser.nickname.length>1) ? this.props.otherUser.nickname : this.props.otherUser.first_name} wants`
    let language = (this.props.selected === 1) ? this.props.lang_one.language : this.props.lang_two.language
    return(
      <div style={{paddingTop: 24, paddingBottom: 24}}>
        <h5 style={{color: '#01579B', fontWeight: 200}}>These are the activities {text}</h5>
        <h5 style={{color: '#01579B', fontWeight: 200}}>to do during the {language} Lex.</h5>
      </div>
    )
  }

  render() {
    return(
      <div>
        <div style={{justifyContent: 'space-evenly', maxWidth: 350, flexDirection: 'row', margin: 'auto', display: 'flex', marginTop: 24}}>
          <div style={this.style(1)} onClick={() => this.props.changeSelect(1)}>
            <p style={{color: (this.props.selected === 1 ? 'white' : '#03A9F4'), fontSize: 16, fontWeight: 600, paddingBottom: 10}}>{this.props.lang_one.native}</p>
            <p style={{color: (this.props.selected === 1 ? 'white' : '#03A9F4'), fontSize: 14, fontWeight: 200}}>{moment(this.props.meeting.meeting_time).format("h:mm")}-{moment(this.props.meeting.meeting_time).add(30, 'minutes').format("h:mm a")}</p>
          </div>
          <div style={this.style(2)} onClick={() => this.props.changeSelect(2)}>
            <p style={{color: (this.props.selected === 2 ? 'white' : '#03A9F4'), fontSize: 16, fontWeight: 600, paddingBottom: 10}}>{this.props.lang_two.native}</p>
            <p style={{color: (this.props.selected === 2 ? 'white' : '#03A9F4'), fontSize: 14, fontWeight: 200}}>{moment(this.props.meeting.meeting_time).add(30, 'minutes').format("h:mm")}-{moment(this.props.meeting.meeting_time).add(60, 'minutes').format("h:mm a")}</p>
          </div>
        </div>
        {this.instructionText()}
      </div>
    )
  }

}

export default LexSchedule;
